import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
export const SpacePageRoute = Dynamic(async () => {
    const { default: SpacePageWrapper } = await import('#pplx/frontend/apps/ask/spa/SpacePageWrapper.js');
    return { default: SpacePageWrapper };
}, { critical: true });
//# sourceMappingURL=SpacePageRoute.js.map